import Vue from 'vue'
import i18n from '../i18n'
import api from '@/plugins/api'
import '../plugins/globals.ts'

import '../theme/theme.scss'

checkSubdomain()

Vue.config.productionTip = false
let elements = document.getElementsByTagName('module')
let modules: any = {}
for (let element of elements) {
  modules[element.id] = element.getAttribute('name')
}

for (let id in modules) {
  if (!id || id === '') {
    continue
  }
  let ComponentModule = modules[id]
  new Vue({
    render: (h) => h(require('../modules/' + ComponentModule + '.vue').default),
  }).$mount('module#' + id)
}

import initStore from '../store/init'
export { initStore, i18n }

function checkSubdomain() {
  let a = new String(window.location)
  a = a.replace('http://', '')
  a = a.replace('https://', '')
  a = a.replace('www.', '')
  a = a.substring(0, a.indexOf('.'))
  console.log('subdomain = ', a)

  api()
    .get(`/check-tenant/${a}`)
    .then((response: any) => {
      const res = response.data.data
      if (res.isActive !== true) {
        window.location.href = 'https://yourshop.al'
      }
    })
}
